import axios from 'utils/axios';
import Manage from '../types/manage';

export const updateServicePackage = (id: string, servicePackages: Manage.ServicePackages.Request) => {
  return axios.put(`/api/v1/servicepackages/mfo/${id}`, { ...servicePackages });
};
